import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import NC from "./App/Pages/NC";
import POS from "./App/Pages/POS";
import Header from "./App/Components/Header";
import Footer from "./App/Components/Footer";
import Error404 from "./App/Components/Error404";
function App() {
  return (
    <>
      <Header />
      <Router>
        <Switch>
          <Route path="/" exact component={NC} />
          <Route path="/POS" component={POS} />
          <Route path="*" component={Error404} />
        </Switch>
      </Router>
      <Footer />
    </>
  );
}

export default App;
